<script>
import HeaderMain from "@/components/headers/HeaderMain.vue";
import ExpertController from "@/controllers/ExpertController";
import HeaderSection from "@/components/headers/HeaderSection.vue";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory.vue";
import {setFileFunctions} from "@/mixins/fileFucntions";
import {mapGetters} from "vuex";
import FileContainer from "@/containers/FileContainer.vue";
import {setCryptoProFunctions} from "@/mixins/cryptoProFunctions";
import rules from "@/utils/rules";
import moment from "moment/moment";
moment.locale('ru');
moment.updateLocale('ru', {
  months : [
    "января", "февраля", "марта", "апреля", "мая", "июня", "июля",
    "августа", "сентября", "октября", "ноября", "декабря"
  ]
});

export default {
  name: "ExpertProtocols",
  components: {FileContainer, WrapperPreviewCategory, HeaderSection, HeaderMain},
  mixins: [setFileFunctions, setCryptoProFunctions],
  data() {
    return {
      serverData: null,
      selectList: [
        {id: 1, text: "За"},
        {id: 2, text: "Против"},
        {id: 3, text: "Воздерживаюсь"},
      ],
      loadingFile: false,
      tempComment: null,
      needComment: false,
      tempAnswer: null,
      commentValid: true,
      rules: rules
    }
  },
  mounted() {
    this.getServerData()
    this.checkSystem()
  },
  computed: {
    ...mapGetters('keycloak', {getAuthData: 'getAuthData', userId: 'userId'}),
    ...mapGetters('checkFilled', {getFilesList: 'getFilesList', getFilesListStatus: 'getFilesListStatus'}),
    userUUID() {
      return this.getAuthData?.sub
    },
    isBlocked() {
      return false
    },
    dateNow() {
      return moment(Date.now()).format('«DD» MMMM YYYY г.');
      // return '«23» декабря 2024 г.'
    }
  },
  methods: {
    hasConfirmFile(expertId, protocolId) {
      const cffile = this.getFilesList.filter(item => item.fileType === this.fileType(expertId, protocolId))[0];
      return cffile !== undefined && cffile !== null && !!cffile.id;
    },
    filesConfig(expertId, protocolId, isBlock) {
      return [{
        name: 'Подписанный лист голосования',
        types: ['application/pdf'],
        typesForChose: ['application/pdf'],
        id: null,
        fileType: this.fileType(expertId, protocolId),
        canUpload: !this.hasConfirmFile(expertId, protocolId) && !isBlock
      }]
    },
    uploadFile(expertId, protocolId) {
      this.$refs[this.fileType(expertId, protocolId)][0].files[0].canUpload = false
      this.$refs[this.fileType(expertId, protocolId)][0].files[0].disabled = true
    },
    hasAllAnswers(protocolId, expertId) {
      const protocol = this.serverData.find(el => el.id === protocolId);
      if (protocol) {
        if (protocol.questions) {
          for (const question of protocol.questions) {
            if (question.answers === undefined) {
              return false;
            }
            if (question.answers.filter(el => el.expertId === expertId).length === 1)
              continue;
            else
              return false;
          }
          return true;
        }
      }
      return false
    },
    fileType(expertId, protocolId) {
      return `EXPERT_${expertId}_${protocolId}`
    },
    initFiles(data) {
      console.log(this.$refs[data.fileType][0])
      this.$refs[data.fileType][0].initFiles()
    },
    async getServerData() {
      try {
        this.serverData = await ExpertController.getProtocols();
      } catch (e) {
        console.log("getServerData", e)
        throw e;
      }
    },
    revertAnswer() {
      this.needComment = false;
      this.commentValid = true;
      const protocol = this.serverData.find(el => el.id === this.tempAnswer.protocolId);
      const question = protocol.questions.find(el => el.id === this.tempAnswer.id);
      if (question.answers.length === 0){
        question.answer = null
      } else {
        question.answer = question.answers[0].answerNumber
      }
    },
    async setAnswer(question, event) {
      // if (event > 1 && (this.tempComment === null || this.tempComment.length === 0)) {
      //   this.commentValid = this.$refs?.commentDialog?.validate()
      //   this.needComment = true;
      //   this.tempAnswer = question;
      //   return;
      // }
      try {
        const idx = this.serverData.findIndex(el => el.id === question.protocolId);
        const res = await ExpertController.setAnswer(question.protocolId, question.id, event, this.tempComment)
        if (idx !== -1)
          this.serverData.splice(idx, 1, res)
        this.tempComment = null;
        this.needComment = false;
        this.commentValid = true;
      } catch (e) {
        console.log("getServerData", e)
        throw e;
      }
    },
    async getReport(protocolId, date, liveSign = false) {
      console.log(this.dateNow, date)
      if (liveSign)
        await this.downloadPrint('ExpertForm', 'downloadingPrint', 'Лист голосования (для проверки).pdf', 'application/pdf', `?expertId=${this.userUUID}&protocolId=${protocolId}&live_sign=true&sign_date=${date}`)
      else {
        this.loadingFile = true;
        await this.downloadPrint('ExpertForm', 'downloadingPrint', 'Лист голосования (для проверки).pdf', 'application/pdf', `?expertId=${this.userUUID}&protocolId=${protocolId}`)
      }
      this.loadingFile = false;
    },
  }
}
</script>

<template>
  <section>
    <HeaderMain title="Заполнение листов голосования"/>
    <v-row v-for="item in serverData" :key="item.id">
      <WrapperPreviewCategory>
        <HeaderSection class="flex flex-column"><p class="font-weight-bold" style="text-align: center">Лист голосования (<a v-if="item.link" :href="item.link">ПРОТОКОЛ № {{ item.number }}</a><template v-else>Протокол № {{ item.number }}</template>)</p>
          <p class="text-justify">{{ item.title }}</p></HeaderSection>
        <v-row v-for="quest in item.questions" :key="quest.id">
          <v-col cols="10" class="text-justify"><span v-if="quest.number">{{ quest.number }}.</span> {{ quest.question }}
            <span v-if="quest.link"><a :href="quest.link">Приложение</a></span>
          </v-col>
          <v-col cols="2">
            <v-select
                :items="selectList"
                placeholder="Не рассмотрено"
                :ref="`quest_${quest.id}`"
                item-title="text"
                item-value="id"
                v-model="quest.answer"
                :disabled="hasConfirmFile(userUUID, item.id)"
                @change="setAnswer(quest, $event)"
            >
            </v-select>
          </v-col>
          <div v-if="quest.answers[0]?.comment">
            <v-col>Пояснение: {{ quest.answers[0].comment }}</v-col>
          </div>
        </v-row>
        <v-divider></v-divider>
        <v-row v-if="hasAllAnswers(item.id, userUUID) && !item.isBlock">
          <v-col class="d-flex justify-start">
            <v-btn
                v-if="!hasConfirmFile(userUUID, item.id)"
                class="blue__v-btn mr-5 mt-2"
                :loading="loadingFile"
                @click="getReport(item.id)"
            >
              Проект листа голосования
            </v-btn>
          </v-col>
          <template v-if="isValidSystemSetup && !hasConfirmFile(userUUID, item.id) && !item.isBlock && dateNow === item.protocolDate">
            <v-col cols="4">
              <div v-if="isValidSystemSetup">
                <v-autocomplete
                    v-model="chosenCertificate"
                    :items="certificatesList"
                    label="Выберите сертификат, которым будет произведена подпись данных"
                    no-data-text="Нет доступных сертификатов"
                    dense
                    class="mt-2"
                    clearable
                    outlined
                ></v-autocomplete>
              </div>
            </v-col>
            <v-col cols="2">
              <v-btn class="blue__v-btn mt-2" :disabled="item.isBlock || !isValidSystemSetup" :loading="signingFile"
                     @click="signFile('ExpertForm', 'downloadingPrint', fileType(userUUID, item.id), userId, `?expertId=${userUUID}&protocolId=${item.id}&sign_date=${item.protocolDate}`)">
                Подписать
              </v-btn>
              <div v-if="!isValidSystemSetup">
                  <span class="red--text">Не установлен CryptoPro CAdES или плагин работает не правильно. Проверить проблемы можно на странице
                    <a href="https://cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html">Проверка создания электронной подписи CAdES-BES</a></span>
              </div>
            </v-col>
          </template>
        </v-row>
        <v-row v-else-if="!item.isBlock">
          <v-col class="d-flex justify-center red--text">
            Возможность просмотра листа согласования и подписания откроется после выбора всех ответов
          </v-col>
        </v-row>
        <v-row v-if="hasAllAnswers(item.id, userUUID) && !hasConfirmFile(userUUID, item.id) && !item.isBlock" class="mt-12">
          <a @click="getReport(item.id, item.protocolDate, true)">Cкачать форму листа голосования</a>
        </v-row>
        <v-row v-if="hasAllAnswers(item.id, userUUID)" dense>
          <v-col cols="6">
            <file-container :cols="8" :files-config="filesConfig(userUUID, item.id, item.isBlock)" :disabled="item.isBlock || hasConfirmFile(userUUID, item.id)"
                            :ref="fileType(userUUID, item.id)" @upload-file="uploadFile(userUUID, item.id)"/>
          </v-col>
        </v-row>
      </WrapperPreviewCategory>
    </v-row>
    <v-dialog v-model="needComment" max-width="700" persistent>
      <v-card>
        <v-form
            ref="commentDialog"
            :valid="commentValid"
            lazy-validation
        >
          <v-card-title>
            <h2>Введите пояснение, почему вы {{ tempAnswer?.answer === 2 ? "против" : "воздерживаетесь от" }} решения</h2>
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col>
                <v-textarea
                    v-model="tempComment"
                    class="light-brown-color-background rounded"
                    style="border: 1px solid gray"
                    prepend-inner-icon="mdi-comment"
                    clear-icon="mdi-close-circle"
                    clearable
                    dense
                    required
                    :rules="[rules.required]"
                    rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-btn class="blue__v-btn" @click="setAnswer(tempAnswer, tempAnswer.answer)">Принять решение</v-btn>
              </v-col>
              <v-col style="text-align: right;">
                <v-btn class='white__v-btn ml-2' @click="revertAnswer()">Отменить</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </section>
</template>

<style scoped>

</style>